var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"history-list"},_vm._l((_vm.actions),function(item){return _c('history-item',{key:item.id,attrs:{"action":item,"all":_vm.all}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }